// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__26Amv","description":"PatientConsentPreview_description__jEtKN"};